module.exports = __webpack_public_path__ + "img/icon-black-waterproof.d9e079a3.png";